import { observer } from 'mobx-react-lite'
import Styles from './CreditUsageDropdown.module.scss'

import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { CreditsBalanceModal } from './components/CreditsBalanceModal/CreditsBalanceModal'
import { useCreditUsage } from 'hooks/useCreditUsage'
import { Tooltip } from 'components/Tooltip/Tooltip'

export const CreditUsageDropdown = observer(({ showWhenTrialing = false }: { showWhenTrialing?: boolean }) => {
  const workspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const {
    tierUsageStore: { currentSubscription },
  } = useRootStore()
  const isTrialing = currentSubscription?.status === 'trialing'
  const isOnPioneer = currentSubscription?.plan === PaymentPlanKey.VirtualMarketer
  const isOnPioneerTrial = isTrialing && isOnPioneer
  const { creditsRemaining, isOutOfCredits, isLowOnCredits, canAutoReload } = useCreditUsage()
  const isCanceledOrTrialing = currentSubscription?.status === 'canceled' || currentSubscription?.status === 'trialing'
  const isAutoReloading = workspace?.auto_reload_credits && canAutoReload && !isLowOnCredits

  if (
    !workspace?.is_virtual_marketer ||
    workspace.is_ap_freemium ||
    isOnPioneerTrial ||
    !currentSubscription ||
    (!showWhenTrialing && isCanceledOrTrialing) ||
    isAutoReloading
  ) {
    return null
  }

  const openCreditsBalanceModal = () => {
    openModal(CreditsBalanceModal)
  }

  if (workspace.auto_reload_credits && !canAutoReload) {
    return (
      <Tooltip hide={false} placement="bottom" label="Auto-Reload is ON">
        <Button frontIcon={Credits} variant="tertiary" className={Styles.button} onPress={openCreditsBalanceModal}>
          Budget reached
        </Button>
      </Tooltip>
    )
  }

  return (
    <Button frontIcon={Credits} variant="tertiary" className={Styles.button} onPress={openCreditsBalanceModal}>
      {isOutOfCredits || isLowOnCredits ? 'Add More Credits' : `${creditsRemaining} Credits`}
    </Button>
  )
})
